import { createContext } from 'react';
import { HostQualityContextProps } from './hostQuality/types/HostQuality.types';

const HostQualityContext = createContext<HostQualityContextProps | undefined>(
  undefined,
);

export default HostQualityContext;
